import { TextField, Button, Box, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import React, { useEffect } from "react";
import "./Policywallet.scss";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ArticleIcon from "@mui/icons-material/Article";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import DatePicker from "../../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import SlidingPanel from "react-sliding-side-panel";
import PolicyDetail from "./PolicyDetails/PolicyDetails";
import SearchDropdown from "../../../../Supporting files/SearchDropdown/SearchDropdown";

function Policywallet() {
  const [policyDetailStatus, setPolicyDetailStatus] = React.useState(false);
  const [dataGroupPolicy, setDataGroupPolicy] = React.useState([
    {
      logo: "",
      line_one: "",
      line_two_titile: "",
      line_two_desc: "",
      line_three_title: "",
      line_three_desc: "",
      background_color: "",
      icon_color: "",
      text_color: "",
    },
  ]);

  //Add Policy Variables
  const [addPolicyStatus, setAddPolicyStatus] = React.useState(false);
  const [policyType, setPolicyType] = React.useState("");
  const [policyExpiry, setPolicyExpiry] = React.useState<Date | null>(null);
  const [policyName, setPolicyName] = React.useState("");
  const [uploadDocument, setUploadDocument] = React.useState({
    name: "file_path",
  });
  const [warnPolicyType, setWarnPolicyType] = React.useState(false);
  const [warnPolicyExpiry, setWarnPolicyExpiry] = React.useState(false);
  const [warnPolicyName, setWarnPolicyName] = React.useState(false);
  const [warnUploadDocument, setWarnUploadDocument] = React.useState(false);

  //New Claim Request Variables
  const [claimNewRequest, setClaimNewRequest] = React.useState(false);
  const [relation, setRelation] = React.useState("");
  const [kycDocumentStatus, setKycDocumentStatus] = React.useState("kyc");
  const [selectDocument, setSelectDocument] = React.useState("");
  const [claimPolicyName, setClaimPolicyName] = React.useState("");
  const [selectPolicy, setSelectPolicy] = React.useState("");
  const [insuredPerson, setInsuredPerson] = React.useState("");
  const [state, setState] = React.useState("");
  const [city, setCity] = React.useState("");
  const [hospital, setHospital] = React.useState("");
  const [myDocument, setMyDocument] = React.useState("");
  const [claimUploadDocument, setClaimUploadDocument] = React.useState("");
  const [warnClaimPolicyName, setWarnClaimPolicyName] = React.useState(false);
  const [warnInsuredPerson, setWarnInsuredPerson] = React.useState(false);
  const [warnState, setWarnState] = React.useState(false);
  const [warnCity, setWarnCity] = React.useState(false);
  const [warnHospital, setWarnHospital] = React.useState(false);
  const [warnMyDocument, setWarnMyDocument] = React.useState(false);
  const [warnClaimUploadDocument, setWarnClaimUploadDocument] =
    React.useState(false);

  //Add Member variables
  const [addMemberStatus, setAddMemberStatus] = React.useState(false);
  const [name, setName] = React.useState("");
  const [relationship, setRelationship] = React.useState("");
  const [age, setAge] = React.useState("");
  const [warnName, setWarnName] = React.useState(false);
  const [warnRelationship, setWarnRelationship] = React.useState(false);
  const [warnAge, setWarnAge] = React.useState(false);
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const [endorsementStatus, setEndorsementStatus] = React.useState(false);
  const [expiry, setExpiryStatus] = React.useState("");
  const [oldValue, setOldValue] = React.useState<Date | null>(new Date());
  const [newValue, setNewValue] = React.useState<Date | null>(new Date());
  const [selectValue, setSelectValue] = React.useState("");
  const [oldValueOne, setOldValueOne] = React.useState<Date | null>(new Date());
  const [newValueOne, setNewValueOne] = React.useState<Date | null>(new Date());
  const [selectValueOne, setSelectValueOne] = React.useState("");
  const [oldsValue, setOldsValue] = React.useState("");
  const [newsValue, setNewsValue] = React.useState("");

  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    if (attrName === "policyType") {
      setPolicyType(event.target.value as string);
      setWarnPolicyType(
        event.target.value.toString().length > 0 ? false : true
      );
    } else if (attrName === "policyName") {
      setPolicyName(event.target.value as string);
      setWarnPolicyName(
        event.target.value.toString().length > 0 ? false : true
      );
    } else if (attrName == "claimPolicyName") {
      setClaimPolicyName(event.target.value.toString());
      setWarnClaimPolicyName(
        event.target.value.toString().length > 0 ? false : true
      );
    } else if (attrName == "insuredPerson") {
      setInsuredPerson(event.target.value.toString());
      setWarnInsuredPerson(
        event.target.value.toString().length > 0 ? false : true
      );
    } else if (attrName == "state") {
      setState(event.target.value.toString());
      setWarnState(event.target.value.toString().length > 0 ? false : true);
    } else if (attrName == "city") {
      setCity(event.target.value.toString());
      setWarnCity(event.target.value.toString().length > 0 ? false : true);
    } else if (attrName == "hospital") {
      setHospital(event.target.value.toString());
      setWarnHospital(event.target.value.toString().length > 0 ? false : true);
    } else if (attrName == "myDocument") {
      setMyDocument(event.target.value.toString());
      setWarnMyDocument(
        event.target.value.toString().length > 0 ? false : true
      );
    } else if (attrName == "relationship") {
      setRelationship(event.target.value.toString());
      setWarnRelationship(
        event.target.value.toString().length > 0 ? false : true
      );
    } else if (attrName == "age") {
      setAge(event.target.value.toString());
      setWarnAge(event.target.value.toString().length > 0 ? false : true);
    }
  };

  const handleChangeTextField = (value: any, attrName: string) => {
    if (attrName === "policyExpiry") {
      setPolicyExpiry(value);
      setWarnPolicyExpiry(value.toString().length > 0 ? false : true);
    } else if (attrName == "name") {
      setName(value);
      setWarnName(value.toString().length > 0 ? false : true);
    }
  };

  useEffect(() => {
    setDataGroupPolicy([
      {
        logo: "https://static.hellopolicy.com/images/Royal_Sundaram.svg",
        line_one: "Health Insurance",
        line_two_titile: "Sum Insured",
        line_two_desc: "5 Lakh",
        line_three_title: "Coverage for",
        line_three_desc: "2 Adults & 1 Child",
        background_color: "#E5E3FF",
        text_color: "#2166AA",
        icon_color: "#2166AA",
      },
      {
        logo: "https://static.hellopolicy.com/images/aditya_birla_health.svg",
        line_one: "Life Insurance",
        line_two_titile: "Sum Assured",
        line_two_desc: "1 Crore",
        line_three_title: "Policy Term",
        line_three_desc: "20 Years",
        background_color: "#FFD8E3",
        text_color: "#EB5757",
        icon_color: "#EB5757",
      },
      {
        logo: "https://static.hellopolicy.com/images/CignaTTK-Health-Insurance-Company-Limited.svg",
        line_one: "Travel Insurance",
        line_two_titile: "Sum Insured",
        line_two_desc: "50,000",
        line_three_title: "Travellers",
        line_three_desc: "1",
        background_color: "#ACD4FB",
        text_color: "#247BCF",
        icon_color: "#247BCF",
      },
    ]);
  }, []);

  const validateAddPolicy = () => {
    let warn_policy_type = policyType.toString().length > 0 ? false : true;
    let warn_policy_expiry =
      policyExpiry == null
        ? true
        : policyExpiry.toString().length > 0
          ? false
          : true;
    let warn_policy_name = policyName.toString().length > 0 ? false : true;
    let warn_upload_document =
      uploadDocument.toString().length > 0 ? false : true;

    setWarnPolicyType(warn_policy_type);
    setWarnPolicyExpiry(warn_policy_expiry);
    setWarnPolicyName(warn_policy_name);
    setWarnUploadDocument(warn_upload_document);

    if (
      warn_policy_type == false &&
      warn_policy_expiry == false &&
      warn_policy_name == false &&
      warn_upload_document == false
    ) {
    }
  };

  const validateClaimRequest = () => {
    let warn_policy_name = claimPolicyName.toString().length > 0 ? false : true;
    let warn_insured_person =
      insuredPerson.toString().length > 0 ? false : true;
    let warn_state = state.toString().length > 0 ? false : true;
    let warn_city = city.toString().length > 0 ? false : true;
    let warn_hospital = hospital.toString().length > 0 ? false : true;
    let warn_my_document = myDocument.toString().length > 0 ? false : true;
    let warn_upload_document =
      claimUploadDocument.toString().length > 0 ? false : true;

    setWarnClaimPolicyName(warn_policy_name);
    setWarnInsuredPerson(warn_insured_person);
    setWarnState(warn_state);
    setWarnCity(warn_city);
    setWarnHospital(warn_hospital);
    setWarnMyDocument(warn_my_document);
    setWarnClaimUploadDocument(warn_upload_document);

    if (
      warn_policy_name == false &&
      warn_insured_person == false &&
      warn_state == false &&
      warn_city == false &&
      warn_hospital == false &&
      warn_my_document == false &&
      warn_upload_document == false
    ) {
    }
  };
  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  const validateAddMember = () => {
    let warn_name = name.toString().length > 0 ? false : true;
    let warn_relationship = relationship.toString().length > 0 ? false : true;
    let warn_age = age.toString().length > 0 ? false : true;

    setWarnName(warn_name);
    setWarnRelationship(warn_relationship);
    setWarnAge(warn_age);

    if (warn_name == false && warn_relationship == false && warn_age == false) {
    }
  };
  const policytype_data = [
    { key: "Car Insurance", value: "Car Insurance" },
    { key: "Bike Insurance", value: "Bike Insurance" },
    { key: "Health Insurance", value: "Health Insurance" },
    { key: "Travel Insurance", value: "Travel Insurance" },
    { key: "Term Insurance", value: "Term Insurance" },
  ];
  const policyname_data = [
    { key: "Car Insurance", value: "Car Insurance" },
    { key: "Bike Insurance", value: "Bike Insurance" },
    { key: "Health Insurance", value: "Health Insurance" },
    { key: "Travel Insurance", value: "Travel Insurance" },
    { key: "Term Insurance", value: "Term Insurance" },
  ];
  const selectPolicy_data = [
    { label: "Car Insurance", value: "Car Insurance" },
    { label: "Bike Insurance", value: "Bike Insurance" },
    { label: "Health Insurance", value: "Health Insurance" },
    { label: "Travel Insurance", value: "Travel Insurance" },
    { label: "Term Insurance", value: "Term Insurance" },
  ];
  const selectValue_data = [
    { label: "Name", value: "Name" },
    { label: "DOB", value: "DOB" },
  ];
  const selectValueOne_data = [
    { label: "Name", value: "Name" },
    { label: "DOB", value: "DOB" },
  ];

  const relationship_data = [
    { key: "Brother", value: "Brother" },
    { key: "Sister", value: "Sister" },
    { key: "Father", value: "Father" },
    { key: "Mother", value: "Mother" },
  ];
  const age_data = [
    { key: "18 Years", value: "18 Years" },
    { key: "19 Years", value: "19 Years" },
    { key: "20 Years", value: "20 Years" },
    { key: "21 Years", value: "21 Years" },
  ];
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };
  const claimPolicyName_data = [
    { label: "Aadhar card", value: "Aadhar card" },
    { label: "Pan card", value: "Pan card" },
  ];
  const insuredPerson_data = [
    { key: "Vikas Saini", value: "Vikas Saini" },
    { key: "Kartike Kakkar", value: "Kartike Kakkar" },
  ];
  const selectState_data = [
    { label: "Uttarakhand", value: "Uttarakhand" },
    { label: "Haryana", value: "Haryana" },
    { label: "Punjab", value: "Punjab" },
    { label: "U.P.", value: "U.P." },
  ];
  const selectCity_data = [
    { label: "Dehradun", value: "Dehradun" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Gurugram", value: "Gurugram" },
    { label: "Noida", value: "Noida" },
  ];
  const hospital_data = [
    { key: "Max Hospital", value: "Max Hospital" },
    { key: "Fortis Hospital", value: "Fortis Hospital" },
  ];
  const myDocument_data = [
    { key: "Policy", value: "Policy" },
    { key: "Other", value: "Other" },
  ];

  return (
    <Grid container spacing={3}>
      <PolicyDetail
        attrName={setPolicyDetailStatus}
        open_status={policyDetailStatus}
        value_update={updateMasterState}
      />
      {/* <-------------------------Endorsement Pop up Start------------------------------> */}
      <SlidingPanel
        type={"right"}
        isOpen={endorsementStatus}
        size={75}
        panelClassName="slidingPanel"
        backdropClicked={() => setEndorsementStatus(false)}
      >
        <Box
          className={
            endorsementStatus == true ? "modalInner show" : "modalInner"
          }
        >
          <Grid container spacing={3} alignItems="center">
            <Grid xs={9}>
              <h4 className="mb-0 text-left">Endorsement</h4>
              <p className="sm-font">
                Please select the values you wish to update and enter the new
                value.
              </p>
            </Grid>
            <Grid xs={3}>
              <Link
                className="close-button"
                onClick={() => {
                  setEndorsementStatus(false);
                }}
              />
            </Grid>
          </Grid>

          <div className="scrollable_area">
            <Grid
              container
              spacing={3}
              justifyContent="center"
              alignItems="center"
            >
              <Grid xs={4}>
                <SearchDropdown
                  class_name="inputField"
                  title="Select Value"
                  value={selectValue}
                  attrName={setSelectValue}
                  value_update={updateMasterState}
                  data={selectValue_data}
                  error_message="Please select Select Value"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={3}>
                <DatePicker
                  class_name="inputField"
                  title="Old Value"
                  value={oldValue}
                  attrName={setOldValue}
                  value_update={updateMasterState}
                  error_message="Please enter Start Date"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={3} className="inputField">
                <DatePicker
                  class_name="inputField"
                  title="New Value"
                  value={newValue}
                  attrName={setNewValue}
                  value_update={updateMasterState}
                  error_message="Please enter New Value"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={2}>
                <Link
                  className="redBtn delete"
                  underline="none"
                  onClick={() => { }}
                >
                  Remove
                </Link>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
              justifyContent="center"
              alignItems="center"
            >
              <Grid xs={4}>
                <SearchDropdown
                  class_name="inputField"
                  title="Select Value"
                  value={selectValue}
                  attrName={setSelectValue}
                  value_update={updateMasterState}
                  data={selectValueOne_data}
                  error_message="Please select Select Value"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={3}>
                <DatePicker
                  class_name="inputField"
                  title="Old Value"
                  value={oldValueOne}
                  attrName={setOldValueOne}
                  value_update={updateMasterState}
                  error_message="Please enter Start Date"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={3} className="inputField">
                <DatePicker
                  class_name="inputField"
                  title="New Value"
                  value={newValueOne}
                  attrName={setNewValueOne}
                  value_update={updateMasterState}
                  error_message="Please enter New Value"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={2}>
                <Link
                  className="greenBtn addfile"
                  underline="none"
                  onClick={() => { }}
                >
                  Add
                </Link>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn mt-4">
                <Button
                  variant="contained"
                  className="submitBtn fixedbtn"
                  onClick={() => { }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </div>
        </Box>
      </SlidingPanel>
      {/* <-------------------------Endorsement Pop up End------------------------------> */}

      <SlidingPanel
        type={"right"}
        isOpen={addPolicyStatus}
        size={75}
        panelClassName="slidingPanel"
        backdropClicked={() => setAddPolicyStatus(false)}
      >
        <Box
          className={addPolicyStatus == true ? "modalInner show" : "modalInner"}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid xs={9}>
              <h4 className="mb-0 text-left">Add New Policy</h4>
            </Grid>
            <Grid xs={3}>
              <Link
                className="close-button"
                onClick={() => {
                  setAddPolicyStatus(false);
                }}
              />
            </Grid>
          </Grid>

          <div className="scrollable_area">
            <Grid container spacing={3}>
              <Grid xs={12} sx={{ padding: "0px" }}>
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Policy Type"
                      value={policyType}
                      attrName={setPolicyType}
                      value_update={updateMasterState}
                      dropdown_data={policytype_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <DatePicker
                      class_name="inputField"
                      title="Policy Expiry"
                      value={policyExpiry}
                      attrName={setPolicyExpiry}
                      value_update={updateMasterState}
                      error_message="Please enter policy expiry."
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={12}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Policy Name"
                      value={policyName}
                      attrName={setPolicyName}
                      value_update={updateMasterState}
                      dropdown_data={policyname_data}
                      warn_status={false}
                    />
                  </Grid>

                  <Grid xs={12}>
                    <Grid
                      container
                      spacing={0}
                      justifyContent="center"
                      className="mb-5 pl-0"
                    >
                      <Grid xs={10} className="inputField uploadFile">
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          label="Select file"
                          variant="outlined"
                          className="textarea"
                        />
                      </Grid>
                      <Grid xs={2}>
                        <Button variant="contained" className="browsebtn">
                          Browse
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn mt-4">
                <Button
                  variant="contained"
                  className="submitBtn fixedbtn"
                  onClick={() => { }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </div>
        </Box>
      </SlidingPanel>
      {/* <-------------------------Add policy Pop up End------------------------------> */}
      {/* <-------------------------Claim new request Pop up Start------------------------------> */}

      <SlidingPanel
        type={"right"}
        isOpen={claimNewRequest}
        size={75}
        panelClassName="slidingPanel"
        backdropClicked={() => setClaimNewRequest(false)}
      >
        <Box
          className={addPolicyStatus == true ? "modalInner show" : "modalInner"}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid xs={9}>
              <h4 className="mb-0 text-left">Initiate New Claim Request</h4>
            </Grid>
            <Grid xs={3}>
              <Link
                className="close-button"
                onClick={() => {
                  setClaimNewRequest(false);
                }}
              />
            </Grid>
          </Grid>

          <div className="scrollable_area">
            <Grid container spacing={3}>
              <Grid xs={12}>
                <div className="selector width-per-item">
                  <Button
                    className={kycDocumentStatus === "kyc" ? "selection" : ""}
                    style={{ color: "#000" }}
                    onClick={() => {
                      setKycDocumentStatus("kyc");
                    }}
                  >
                    <ArticleIcon /> Claim Intimation
                  </Button>
                  <Button
                    className={
                      kycDocumentStatus === "policy" ? "selection" : ""
                    }
                    style={{ color: "#000" }}
                    onClick={() => {
                      setKycDocumentStatus("policy");
                    }}
                  >
                    <AccountBalanceWalletIcon /> Cashless Request
                  </Button>
                </div>
                <p className="small-text">
                  Use Cashless Request for planned hospitalisation where bills
                  are settled directly by Insurer.
                </p>
              </Grid>

              {kycDocumentStatus == "kyc" ? (
                <Grid xs={12}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Select Policy"
                    value={selectPolicy}
                    attrName={setSelectPolicy}
                    value_update={updateMasterState}
                    data={selectPolicy_data}
                    warn_status={false}
                    error_message="Please select select Policy"
                  />
                </Grid>
              ) : null}
              {kycDocumentStatus == "policy" ? (
                <Grid xs={12}>
                  <SearchDropdown
                    class_name="inputField"
                    title=" Policy Name"
                    value={claimPolicyName}
                    attrName={setClaimPolicyName}
                    value_update={updateMasterState}
                    data={claimPolicyName_data}
                    warn_status={false}
                    error_message="Please select Policy Name"
                  />
                </Grid>
              ) : null}
              <Grid xs={12}>
                <SelectDropdown
                  class_name="inputField"
                  title="Insured Person"
                  value={insuredPerson}
                  attrName={setInsuredPerson}
                  value_update={updateMasterState}
                  dropdown_data={insuredPerson_data}
                  warn_status={false}
                />
              </Grid>

              <Grid xs={6}>
                <SearchDropdown
                  class_name="inputField"
                  title="State"
                  value={state}
                  attrName={setState}
                  value_update={updateMasterState}
                  data={selectState_data}
                  warn_status={false}
                  error_message="Please select state"
                />
              </Grid>
              <Grid xs={6}>
                <SearchDropdown
                  class_name="inputField"
                  title="City"
                  value={city}
                  attrName={setCity}
                  value_update={updateMasterState}
                  data={selectCity_data}
                  warn_status={false}
                  error_message="Please select City"
                />
              </Grid>
              <Grid xs={12}>
                <SelectDropdown
                  class_name="inputField"
                  title="Hospital"
                  value={hospital}
                  attrName={setHospital}
                  value_update={updateMasterState}
                  dropdown_data={hospital_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={12}>
                <SelectDropdown
                  class_name="inputField"
                  title=" My Document"
                  value={myDocument}
                  attrName={setMyDocument}
                  value_update={updateMasterState}
                  dropdown_data={myDocument_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={12}>
                <Grid
                  container
                  spacing={0}
                  justifyContent="center"
                  className="mb-5 pl-0"
                >
                  <Grid xs={10} className="inputField uploadFile">
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      label="Select file"
                      variant="outlined"
                      className="textarea"
                    />
                  </Grid>
                  <Grid xs={2}>
                    <Button variant="contained" className="browsebtn">
                      Browse
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn">
                <Button
                  variant="contained"
                  className="submitBtn fixedbtn"
                  onClick={() => { }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </div>
        </Box>
      </SlidingPanel>

      {/* <-------------------------Claim new request Pop up End------------------------------> */}
      {/* <-------------------------Add new member Pop up Start------------------------------> */}

      <SlidingPanel
        type={"right"}
        isOpen={addMemberStatus}
        size={75}
        panelClassName="slidingPanel"
        backdropClicked={() => setAddMemberStatus(false)}
      >
        <Box
          className={addMemberStatus == true ? "modalInner show" : "modalInner"}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid xs={9}>
              <h4 className="mb-0 text-left">Add New Member</h4>
            </Grid>
            <Grid xs={3}>
              <Link
                className="close-button"
                onClick={() => {
                  setAddMemberStatus(false);
                }}
              />
            </Grid>
          </Grid>

          <div className="scrollable_area">
            <Grid container spacing={2} justifyContent="center">
              <Grid xs={12}>
                <RKTextField
                  class_name="inputField"
                  title={"Name"}
                  value={name}
                  attrName={setName}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6} className="inputField">
                <SelectDropdown
                  class_name="inputField"
                  title="Relationship"
                  value={relationship}
                  attrName={setRelationship}
                  value_update={updateMasterState}
                  dropdown_data={relationship_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6} className="inputField">
                <SelectDropdown
                  class_name="inputField"
                  title="Age"
                  value={age}
                  attrName={setAge}
                  value_update={updateMasterState}
                  dropdown_data={age_data}
                  warn_status={false}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn">
                <Button
                  variant="contained"
                  className="submitBtn fixedbtn"
                  onClick={() => { }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </div>
        </Box>
      </SlidingPanel>

      {/* <-------------------------Add new member Pop up End------------------------------> */}
      <Grid xs={6}>
        <h3 className="mb-0">Policy Wallet</h3>
      </Grid>
      <Grid xs={6} className="text-right">
        <Link
          underline="none"
          className="greenBtn docs"
          onClick={() => {
            setAddPolicyStatus(true);
          }}
        >
          Add Policy <span className="docs"></span>
        </Link>
      </Grid>
      <Grid xs={12}>
        <Grid container spacing={2} sx={{ paddingLeft: "0px" }}>
          <Grid xs={12}>
            <h5 className="mb-0">Group Policy</h5>
          </Grid>
          {dataGroupPolicy.map((item, index) => (
            <Grid md={6} lg={4}>
              <Box className="walletPolicyBox">
                <Box className="walletPolicyBox_inner">
                  <Grid
                    container
                    spacing={2}
                    className="forntSide"
                    style={{ backgroundColor: item.background_color }}
                  >
                    <Grid xs={6}>
                      <img
                        src={item.logo}
                        className="insurerlogo"
                        alt="Insurer"
                      />
                    </Grid>
                    <Grid className="text-right align-self-center" xs={6}>
                      <p>{item.line_one}</p>
                    </Grid>
                    <Grid xs={6}>
                      <p className="valuedText">
                        {item.line_two_titile}
                        <span className="inrIcon">{item.line_two_desc}</span>
                      </p>
                    </Grid>
                    <Grid className="text-right" xs={6}>
                      <p className="valuedText">
                        {item.line_three_title}
                        <span>{item.line_three_desc}</span>
                      </p>
                    </Grid>
                  </Grid>
                  <Grid
                    className="backSide"
                    container
                    spacing={2}
                    style={{ backgroundColor: item.background_color }}
                  >
                    <Grid xs={4} style={{ paddingTop: "0px" }}>
                      <Grid
                        container
                        spacing={1}
                        justifyContent="space-between"
                        style={{ height: "100%" }}
                      >
                        <Grid xs={12} className="endorsement">
                          <Link
                            underline="none"
                            style={{ color: item.text_color }}
                          >
                            <span
                              className="icon"
                              style={{
                                backgroundColor: item.icon_color,
                              }}
                            ></span>
                            Endorsement
                          </Link>
                        </Grid>
                        <Grid xs={12} className="ecard">
                          <Link
                            underline="none"
                            style={{ color: item.text_color }}
                          >
                            <span
                              className="icon"
                              style={{
                                backgroundColor: item.icon_color,
                              }}
                            ></span>
                            E-card
                          </Link>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid xs={4} style={{ paddingTop: "0px" }}>
                      <Grid
                        container
                        spacing={1}
                        justifyContent="space-between"
                        style={{ height: "100%" }}
                      >
                        <Grid xs={12} className="registerclaim">
                          <Link
                            underline="none"
                            style={{ color: item.text_color }}
                          >
                            <span
                              className="icon"
                              style={{
                                backgroundColor: item.icon_color,
                              }}
                            ></span>
                            Register Claim
                          </Link>
                        </Grid>
                        <Grid xs={12} className="addmember">
                          <Link
                            underline="none"
                            style={{ color: item.text_color }}
                          >
                            <span
                              className="icon"
                              style={{
                                backgroundColor: item.icon_color,
                              }}
                            ></span>
                            Add Member
                          </Link>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid xs={4} style={{ paddingTop: "0px" }}>
                      <Grid
                        container
                        spacing={1}
                        justifyContent="center"
                        style={{
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Grid className="ecard">
                          <Link
                            underline="none"
                            style={{ color: item.text_color }}
                            onClick={() => {
                              console.log("Tap");
                              setPolicyDetailStatus(true);
                            }}
                          >
                            <span
                              className="icon"
                              style={{
                                backgroundColor: item.icon_color,
                              }}
                            ></span>
                            Policy Details
                          </Link>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>
          ))}
          <Grid xs={12}>
            <h5 className="mb-0">Retail Policy</h5>
          </Grid>
          {dataGroupPolicy.map((item, index) => (
            <Grid md={6} lg={4}>
              <Box className="walletPolicyBox">
                <Box className="walletPolicyBox_inner">
                  <Grid
                    container
                    spacing={2}
                    className="forntSide"
                    style={{ backgroundColor: item.background_color }}
                  >
                    <Grid xs={6}>
                      <img
                        src={item.logo}
                        className="insurerlogo"
                        alt="Insurer"
                      />
                    </Grid>
                    <Grid className="text-right align-self-center" xs={6}>
                      <p>{item.line_one}</p>
                    </Grid>
                    <Grid xs={6}>
                      <p className="valuedText">
                        {item.line_two_titile}
                        <span className="inrIcon">{item.line_two_desc}</span>
                      </p>
                    </Grid>
                    <Grid className="text-right" xs={6}>
                      <p className="valuedText">
                        {item.line_three_title}
                        <span>{item.line_three_desc}</span>
                      </p>
                    </Grid>
                    <Grid xs={6}>
                      <p className="valuedText">
                        Premium/year
                        <span className="inrIcon">2,086</span>
                      </p>
                    </Grid>
                    <Grid xs={6} className="text-right">
                      <p className="valuedText">
                        Policy Expiry
                        <span>01/08/2022</span>
                      </p>
                    </Grid>
                  </Grid>
                  {/* Flip Side */}
                  <Grid
                    className="backSide"
                    container
                    spacing={2}
                    style={{ backgroundColor: item.background_color }}
                  >
                    <Grid xs={4}>
                      <Grid
                        container
                        spacing={2}
                        justifyContent="space-around"
                        style={{ flexDirection: "column", height: "100%" }}
                      >
                        <Grid xs={12} className="endorsement">
                          <Link
                            underline="none"
                            style={{ color: item.text_color }}
                            onClick={() => {
                              setEndorsementStatus(true);
                            }}
                          >
                            <span
                              className="icon"
                              style={{
                                backgroundColor: item.icon_color,
                              }}
                            ></span>
                            Endorsement
                          </Link>
                        </Grid>
                        <Grid xs={12} className="ecard">
                          <Link
                            underline="none"
                            style={{ color: item.text_color }}
                          >
                            <span
                              className="icon"
                              style={{
                                backgroundColor: item.icon_color,
                              }}
                            ></span>
                            E-card
                          </Link>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid xs={4}>
                      <Grid
                        container
                        spacing={2}
                        justifyContent="space-around"
                        style={{ flexDirection: "column", height: "100%" }}
                      >
                        <Grid className="registerclaim">
                          <Link
                            underline="none"
                            style={{ color: item.text_color }}
                            onClick={() => {
                              setClaimNewRequest(true);
                            }}
                          >
                            <span
                              className="icon"
                              style={{
                                backgroundColor: item.icon_color,
                              }}
                            ></span>
                            Register Claim
                          </Link>
                        </Grid>
                        <Grid className="addmember">
                          <Link
                            underline="none"
                            style={{ color: item.text_color }}
                            onClick={() => {
                              setAddMemberStatus(true);
                            }}
                          >
                            <span
                              className="icon"
                              style={{
                                backgroundColor: item.icon_color,
                              }}
                            ></span>
                            Add Member
                          </Link>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid xs={4}>
                      <Grid
                        container
                        spacing={2}
                        justifyContent="space-around"
                        style={{ flexDirection: "column", height: "100%" }}
                      >
                        <Grid className="ecard">
                          <Link
                            underline="none"
                            style={{ color: item.text_color }}
                          >
                            <span
                              className="icon"
                              style={{
                                backgroundColor: item.icon_color,
                              }}
                            ></span>
                            Renew
                          </Link>
                        </Grid>
                        <Grid className="ecard">
                          <Link
                            underline="none"
                            style={{ color: item.text_color }}
                            onClick={() => {
                              setPolicyDetailStatus(true);
                            }}
                          >
                            <span
                              className="icon"
                              style={{
                                backgroundColor: item.icon_color,
                              }}
                            ></span>
                            Policy Details
                          </Link>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Policywallet;
